import { ModelsFilterParams, NamedModelsFilterParams, OrdersFilterParams } from 'api/Exec/types';

const rootUrl = 'exec';

const ordersUrl = `${rootUrl}/orders`;
const cancelOrderUrl = `${rootUrl}/cancel`;
const ordersListUrl = (page: number, pageSize: number, filter: OrdersFilterParams) => {
  const { search, orgs, tags, status, groupStatus, model, modelApi, minDate, maxDate, type, ordersIds } = filter;
  return [
    ordersUrl,
    `?page=${page}`,
    `&page_size=${pageSize}`,
    `&filter=${search}`,
    `&org_names=${orgs}`,
    `&tags_ids=${tags}`,
    `&status=${status}`,
    `&status_group=${groupStatus}`,
    `&model_name=${model}`,
    `&model_api_name=${modelApi}`,
    `&min_date=${minDate}`,
    `&max_date=${maxDate}`,
    `&type=${type}`,
    `&orders_ids=${ordersIds}`,
  ].join('');
};
const ordersItemUrl = (orderId: string) => `${ordersUrl}/${orderId}`;
const modelsUrl = `${rootUrl}/model`;
const modelsListUrl = (filter: ModelsFilterParams) => {
  const { search, model, modelApiNames, namedModels, isSandbox, isCv, pushDate } = filter;
  return [
    `${rootUrl}/model`,
    `?model_id=${model}`,
    `&image_tag=${search}`,
    `&model_api_names=${modelApiNames}`,
    `&named_models=${namedModels}`,
    `&is_sandbox=${isSandbox}`,
    `&clinical_validated=${isCv}`,
    `&push_date=${pushDate}`,
  ].join('');
};
const modelsApiUrl = `${modelsUrl}/api`;
const modelsEcrUrl = `${modelsUrl}/ecr`;

const namedModelsUrl = `${rootUrl}/named_model`;
const namedModelsListUrl = (filter: NamedModelsFilterParams) => {
  const { search, modelApiNames, imageTag, isEnabled, isSandbox, isCv } = filter;
  return [
    `${namedModelsUrl}`,
    `?named_model=${search}`,
    `&model_api_names=${modelApiNames}`,
    `&image_tag=${imageTag}`,
    `&is_sandbox=${isSandbox}`,
    `&clinical_validated=${isCv}`,
    `&enabled=${isEnabled}`,
  ].join('');
};
const checkNamedModelNameUrl = (namedModel: string) => {
  return [
    `${namedModelsUrl}`,
    `?named_model=${namedModel}`,
    '&exact_search=true',
  ].join('');
};
const namedModelsItemUrl = (namedModelId: string) => `${namedModelsUrl}/${namedModelId}`;
const namedModelsItemHistoryUrl = (namedModelId: string) => `${namedModelsItemUrl(namedModelId)}/history`;

const tagsUrl = `${rootUrl}/tags`;
const tagsItemUrl = (tagId: string) => `${tagsUrl}/${tagId}`;
const tagsListUrl = (page: number, pageSize: number, name: string) => (
  `${tagsUrl}?page=${page}&page_size=${pageSize}&name=${name}`
);

export default {
  ordersUrl,
  ordersListUrl,
  ordersItemUrl,
  cancelOrderUrl,
  modelsUrl,
  modelsListUrl,
  modelsApiUrl,
  modelsEcrUrl,
  namedModelsUrl,
  namedModelsListUrl,
  checkNamedModelNameUrl,
  namedModelsItemUrl,
  namedModelsItemHistoryUrl,
  tagsUrl,
  tagsListUrl,
  tagsItemUrl,
};
